import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import TherapistInputPage from './TherapistInputPage';
import ContributionViewer from './ContributionViewer';
import TherapistQuestionnairePage from './TherapistQuestionnairePage';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import TherapistDashboard from './TherapistDashboard';
import ClientProfilePage from './ClientProfilePage';
import ProtectedTherapistRoute from './ProtectedTherapistRoute';
import ProtectedClientRoute from './ProtectedClientRoute';
import ClientAssessment from './ClientAssessment';
import LandingPage from './LandingPage2';
import NaturalMatchmakerPage from './NaturalMatchmaker';
import VelaTreeLandingPage from './VelaTreeLanding'
import MindaeraPitchDeck from './PitchDeck';
import MindaeraOnePager from './MindaeraOnePager';
import FundraisingWorkshop from './FundraisingWorkshop';
import BestFitnessOnePager from './bestFitness';
// import BestFitnessOffer from './BestFitnessOfferPage';
import MindfulnessMatcher from './addicere';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing page as the main entry point */}
        <Route path="/" element={<LandingPage />} />
        {/* <Route path="/bestfitness" element={<BestFitnessOnePager />} /> */}
        {/* <Route path="/bestfitness/offer" element={<BestFitnessOffer />} /> */}


        {/* Move the assessment to its own route */}
        <Route path="/client-assessment" element={<ClientAssessment />} />
        
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        <Route 
          path="/therapist-dashboard/*" 
          element={
            <ProtectedTherapistRoute>
              <TherapistDashboard />
            </ProtectedTherapistRoute>
          }
        />
        
        {/* Client profile with nested routes */}
        <Route 
          path="/client-profile/*" 
          element={
            <ProtectedClientRoute>
              <ClientProfilePage />
            </ProtectedClientRoute>
          } 
        />
        
        <Route path="/rick" element={<TherapistInputPage therapistName="rick" />} />
        <Route path="/dave" element={<TherapistInputPage therapistName="dave" />} />

        <Route path="/velatree" element={<VelaTreeLandingPage/>} />
                <Route path="/fundraising-workshop" element={<FundraisingWorkshop/>} />

<Route path="/onePager" element={<MindaeraOnePager/>} />
<Route path="/natural-matchmaker" element={<NaturalMatchmakerPage />} />
        <Route path="/rick/contribution/:contributionId" 
               element={<ContributionViewer therapistName="rick" />} />
        <Route path="/therapist-questionnaire" element={<TherapistQuestionnairePage />} />
        <Route path="/addicere" element={<MindfulnessMatcher />} />

        <Route path="/pitch" element={<MindaeraPitchDeck />} />
        <Route path="/dave/contribution/:contributionId" 
               element={<ContributionViewer therapistName="dave" />} />
        <Route path="/:therapistName/contribution/:contributionId" element={<ContributionViewer />} />
        <Route path="/:therapistName" element={<TherapistInputPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;